
import { Component, Prop, Vue } from "vue-property-decorator";
import PlusIcon from "@/components/icons/ArrowIcon.vue";
import HoveredIcon from "@/components/icons/ArrowIconBlack.vue";
import UIButton from "@/components/button/ui-button.vue";
import GET_CONTRACTOR_VISITS from "@/apollo/calendar/GetContractorVisits.gql";
import GET_MANAGERS from "@/apollo/autocomplete-queries/GetManagers.gql";
import ProjectHeader from "@/components/projects/ProjectHeader.vue";
import NavGrayArrow from "@/components/icons/NavGrayArrow.vue";
import ProfileGray from "@/components/icons/ProfileGray.vue";
import ClockIcon from "@/components/icons/ClockGray.vue";
import LocationGray from "@/components/icons/LocationGray.vue";
import RouteNames from "@/entities/RouteNames";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import EditIconVue from "@/components/icons/EditPenIcon.vue";
import TimeTrackerModal from "@/components/projects/timeTracker/TimeTrackerModalCalendar.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageApplications.vue";
import TimesheetTimeTrackerModal from "@/components/projects/timeTracker/TimesheetTimeTrackerModal.vue";
import TimesheetTimeTrackerModalManual from "@/components/projects/timeTracker/TimesheetTimeTrackerModalManual.vue";
import CheckmarkBlack from "@/components/icons/CheckMarkBlack.vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import MultiSelectComponent from "@/components/MultiSelect.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import ChatIcon from "@/components/icons/MsgIcon.vue";
import TableView from "@/components/v2/table/NewTableResource.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import CalendarIcon from "@/components/icons/ClanderGray.vue";
import InfoIcon from "@/components/icons/MoreInfoIcon.vue";

import {
  Project_Activity,
  Project_Activity_Time,
  User,
  Timesheet,
  Company,
  Contractor,
  Timesheet_Order_By,
  Timesheet_Bool_Exp,
} from "@/generated/graphql";
import moment from "moment";
import NoDataIcon from "@/components/icons/NoDataIcon.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import CalendarEventModal from "@/components/projects/activities/CalendarEventModalResource.vue";
import ContractorClockInModal from "@/components/projects/activities/ContractorClockInModal.vue";
import { StyleValue } from "vue";
import DropdownOption from "@/entities/DropdownOption";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";

@Component({
  components: {
    ArrowIcon,
    PlusIcon,
    HoveredIcon,
    CalendarEventModal,
    TooltipVariants,
    ContractorClockInModal,
    NotesModal,
    UIButton,
    ChatIcon,
    ProjectHeader,
    LoadingOverlay,
    NoDataIcon,
    CrossIcon,
    CrossIconHover,
    CalendarIcon,
    InfoIcon,
    TimeTrackerModal,
    VueCal,
    Tooltip,
    ClockIcon,
    ProfileGray,
    LocationGray,
    TableView,
    CheckmarkBlack,
    NavGrayArrow,
    TimesheetTimeTrackerModal,
    DropdownFilter,
    EmptyListImageProjects,
    TimesheetTimeTrackerModalManual,
    EditIconVue,
    MultiSelectComponent,
  },
  apollo: {
    activities: {
      query: GET_CONTRACTOR_VISITS,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        const allProjectActivities = data.clients.flatMap(
          (client) => client.project_activities
        );
        this.activities = allProjectActivities;
        return allProjectActivities;
      },
    },
     managers: {
      query: GET_MANAGERS,
      variables() {
        return this.managerAutocompleteFilter;
      },
      update(data) {
       return data.manager.map((c) => ({
          id: c.id,
          name: `${c.user.given_name} ${c.user.family_name}`,
        }));
      },
    },
  },
})
export default class ContractorTimesheets extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
   @Prop({ type: Object, required: true }) readonly company!: Company;

  projectActivityTimes: Project_Activity_Time[] = [];
  managers: { id: string; name: string }[] = [];
  isHovered: boolean = false;
  contractor_activities: Project_Activity[] = [];
  contractor: Contractor = null;
  activeActivity: Project_Activity = null;
  showDiscalimer: boolean = false;
  activeTimeEntry: Project_Activity_Time = null;
  eventItems: any[] = [];
  elapsedTime: number = 0;
  weekStatus: string = null;
  TooltipVariants = TooltipVariants;
  submitTimeModalOpen: boolean = false;
  timeTrackerModalOpened = false;
  trackedDate: Date = null;
  orderBy: Timesheet_Order_By[] = [];
  rejectReasonModalOpen: boolean = false;
  weekDisable: boolean = false;
  timesheetList: Timesheet[] = [];
  timesheet: Timesheet[] = [];
  timerStart: string = null;
  timerEnd: string = null;
  week: Date[] = [];
  activeTabIndex: number = 0;
  minEventWidth = 0;
  totalStaffNotes: number = 0;
  submitTime: boolean = false;
  activeTabIndexRes: number = Number(this.$route.query.tab || 0);
  timeTrackerOpen: boolean = false;
  timeTrackerOpenManual: boolean = false;
  currentCellTime: Date = new Date();
  canPause = false;
  currentPage: number = Number(this.$route.query.page || 1);
  companies?: Company[] = [];
  count: number = 0;
  timeSheetId: string = "";
  limit: number = Number(this.$route.query.limit || 10);
  where: Timesheet_Bool_Exp = {};

  sortBy = this.$route.query.sort_by || "created_at";
  offset: number =
    this.currentPage >= 1 ? (this.currentPage - 1) * this.limit : 0;
  sortDirection = this.$route.query.sort_direction || null;

  activities: Project_Activity[] = [];
  retryCount: number = 0;
  showNotesModal: boolean = false;
  selectedEvent: object = {};
  showEventDialog: boolean = false;
  modalEvents: any[];
  showModal: boolean = false;
  isContractorClockInModal: boolean = false;

  selectedManagers: DropdownOption[] = [];
  selectedEventNotes: null;

  toggle() {
    this.$router.push({
      name: RouteNames.CONTRACTOR_PROJECTS,
    });
  }

  get currentDate() {
    return this.$moment(new Date()).format("YYYY-MM-DD");
  }
  handleShow(event) {
    this.selectedEventNotes = event;
    this.showNotesModal = true;
  }

  handleClockModalClose() {
    this.isContractorClockInModal = false;
  } 
  handleClose() {
    this.selectedEventNotes = null;
    this.showNotesModal = false;
  }

  onEventClick(event) {
    if (event.isPlaceholder) {
      this.modalEvents = event.allEvents;
      this.showModal = true;
    }
  }

  closeModal() {
    this.showModal = false; // Hide the modal
  }

  toggleContractorClockInModal(status: boolean) {
    this.isContractorClockInModal = status;
  }

  get manager_option() {
    return this.selectedManagers;
  }

   get managerAutocompleteFilter(): object {
      return {
        where:{
          projects: {
            project_activities: {
              contractor: {
                user_id: {
                  _eq: this.currentUser.id,
                },
              },
            },
          },
        }
      };
    }

  setManagers(input: DropdownOption[]): void {
    this.selectedManagers = input;
    this.$apollo.queries.activities.refetch();
  }

  get manager_options(): DropdownOption[] {
    return this.managers;
  }

  handleFilterReset(): void {
    this.selectedManagers = [];
    this.$apollo.queries.activities.refetch();
  }

  get activitiesArgs(): object {
    const filters: any[] = [{ drafted: { _eq: false } }];
    if (this.selectedManagers.length) {
      filters.push({
        manager_id: { _in: this.selectedManagers.map((r) => r.id) },
      });
    }
    return {
      where: {
        _and: filters,
      },
          projectActivitiesWhere: {
        _and: [
          {
            _or: [
              { accepted: { _is_null: true } },
              { accepted: { _eq: true } }
            ]
          },
          { drafted: { _eq: false } },
          
         {contractor: { user: 
         {id: {_eq: this.currentUser.id}
         }}}
        ]
      }
    };
  }

  createdAt(event): string {
    const date = moment.utc(event.start_time).format("DD MMM, YYYY");
    return `${date}`;
  }
  openTimeTrackerModal(): void {
    this.timeTrackerModalOpened = true;
  }

  get isTimesheetEmpty() {
    return Boolean(this.activities);
  }

  message(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.messageId,
      },
    });
  }
   isNoShow(activity): boolean {
  const currentTime = moment();
  let end_date =activity.end_date || activity.start_date;
  const hasNotCheckedInOrOut =
    activity.checkin_time === null &&
    activity.checkout_time === null;

  if (!hasNotCheckedInOrOut) return false;

  
  if (end_date) {
    const shiftEndDate = moment(end_date).endOf('day');
    if (currentTime.isAfter(shiftEndDate)) return true;
  }

  if (activity.end_time) {
    const shiftEndTime = moment(activity.end_time);
    if (currentTime.isAfter(shiftEndTime)) return true;
  }

  return false;
}
 isNoShowActive(activity): boolean {
  const currentTime = moment();
  let start_time = activity.start_time;
  const hasNotCheckedInOrOut = activity.checkin_time === null

  if (!hasNotCheckedInOrOut) return false;

  
  if (start_time) {
    const timePassed = currentTime.isAfter(start_time);
    if (timePassed) return true;
  }
  return false;
}
  eventClass(event) {
      if (
      !event.completed &&
      !event.drafted &&
      !event.cancelled
    ) {
      if (event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (!event.drafted && this.isNoShowActive(event)) {
        return "NO_SHOW";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (event.accepted === true && !event.checkin_status && !event.checkout_status && !event.completed &&
        !event.drafted &&
        !event.cancelled) {
        return "ACCEPTED";
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if (event.checkin_status === "ON_TIME") {
        return "CLOCKED_IN"; // red
      }
    } else if (
      (event.completed && !event.cancelled && !event.drafted) ||
      (this.isNoShow(event) && event.completed && !event.cancelled && !event.drafted)
    ) {
      if (event.checkout_status === 'OUTSIDE' || event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (!event.drafted && this.isNoShow(event) && !event.completed) {
        return null;
      }
      if (event.checkout_status === "LATE") {
        return "LATE_CLOCK_OUT"                                // after this = late
      }
      if (event.checkout_status === "EARLY") {
        return "EARLY_CLOCK_OUT"; // red
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if ((event.checkout_status === "ON_TIME" && event.checkin_status === "ON_TIME") || (this.isNoShow(event) && event.completed)) {
        return "COMPLETED"; // green
      }
      return 'COMPLETED';

    }
    return "OFFERED";
  }
  eventStatus(event) {
    if (
      !event.completed &&
      !event.drafted &&
      !event.cancelled
    ) {
      if (event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (!event.drafted && this.isNoShowActive(event)) {
        return "NO_SHOW";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (event.accepted === true && !event.checkin_status && !event.checkout_status && !event.completed &&
        !event.drafted &&
        !event.cancelled) {
        return "ACCEPTED";
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if (event.checkin_status === "ON_TIME") {
        return "CLOCKED_IN"; // red
      }
    return "OFFERED";
    } else if (
      (event.completed && !event.cancelled && !event.drafted) ||
      (this.isNoShow(event) && event.completed && !event.cancelled && !event.drafted)
    ) {
      if (event.checkout_status === 'OUTSIDE' || event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (!event.drafted && this.isNoShow(event) && !event.completed) {
        return null;
      }
      if (event.checkout_status === "LATE") {
        return "LATE_CLOCK_OUT"                                // after this = late
      }
      if (event.checkout_status === "EARLY") {
        return "EARLY_CLOCKED_OUT"; // red
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if ((event.checkout_status === "ON_TIME" && event.checkin_status === "ON_TIME") || (this.isNoShow(event) && event.completed)) {
        return "COMPLETED"; // green
      }
      return 'COMPLETED';
    }
    return "OFFERED";
  }
  isUpcoming(activity): boolean {
    const startTime = this.$moment(activity.start_time);
    const today = this.$moment().startOf("day");
    if (startTime.isAfter(today)) {
      return true;
    }
  }


  initial(event): string {
    const firstName = event.firstName;
    const lastName = event.familyName;

    if (!firstName && !lastName) {
      return "";
    }

    const givenName = firstName ? firstName.trimLeft()[0] : "";
    const familyName = lastName ? lastName.trimLeft()[0] : "";
    return `${givenName}${familyName}`;
  }

  bgStyle(event): StyleValue {
    return {
      background: hslColorFromName(this.initial(event) || ""),
      color: "white",
    };
  }

  get events() {
  if (!this.activities?.length) return [];

  // First, transform activities into event objects and sort by start time
  const allEvents = this.activities.map((activity) => {
    const startTime = activity.start_time
      ? this.$moment(activity.start_time).local()
      : null;
    const startDate = activity.start_date
      ? this.$moment.utc(activity.start_date).local()
      : null;
    const endTime = activity.end_time
      ? this.$moment(activity.end_time).local()
      : null;

    const durationInMinutes = endTime
      ? this.$moment(endTime).diff(this.$moment(startTime), "minutes")
      : 0;

    return {
      start: startTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid Start Time",
      start_time: startTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid Start Time",
      end_time: endTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid End Time",
      end: endTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid End Time",
      enable_visit_based_clock_ins: activity.project.enable_visit_based_clock_ins,
      accepted: activity.accepted,
      completed: activity.completed,
      checkin_status: activity.checkin_status || null,
      title: activity.project?.client_name || "N/A",
      location: activity.location || "No Location",
      virtual: activity.virtual || false,
      virtual_meeting_link: activity.virtual_meeting_link || null,
      fallback_num: activity.fallback_num || null,
      background: true,
      status: this.eventStatus(activity),
      firstName: activity.project.manager?.user?.given_name || null,
      familyName: activity.project.manager?.user?.family_name || null,
      resizable: false,
      class: this.eventClass(activity),
      style: {
        width: `100%`,
        left: `0%`,
      },
      id: activity.id,
       eventId: activity.id,
      isLessThanHour: durationInMinutes > 0 && durationInMinutes <= 180,
      messageId: activity.project.manager?.user?.id,
      contractor_id: activity.contractor_id,
      showTime: true,
      eventObject: activity,
      checkOutStatus: activity.checkout_status,
      checkInStatus: activity.checkin_status,
      startDate: startDate,
      notesCount: activity?.contractor_staff_notes_aggregate?.aggregate?.count || 0,
    };
  }).sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

  const processedEvents = [];
  const processedEventIds = new Set();

  // Function to check if two events overlap
  const eventsOverlap = (event1, event2) => {
    return this.$moment(event1.start).isBefore(this.$moment(event2.end)) && 
           this.$moment(event1.end).isAfter(this.$moment(event2.start));
  };

  for (let i = 0; i < allEvents.length; i++) {
    if (processedEventIds.has(allEvents[i].id)) continue;

    const currentEvent = allEvents[i];
    const overlappingEvents = [currentEvent];

    // Find all events that overlap with the current event
    for (let j = i + 1; j < allEvents.length; j++) {
      if (eventsOverlap(currentEvent, allEvents[j])) {
        overlappingEvents.push(allEvents[j]);
      }
    }

    if (overlappingEvents.length === 1) {
      // No overlaps - show full event with all original properties
      processedEvents.push({
        ...currentEvent,
        style: {
          width: "100%",
          left: "0%",
        }
      });
    } else {
      // Has overlaps - show first event and placeholder
      processedEvents.push({
        ...overlappingEvents[0], // Keep all original properties
        style: {
          width: "70%",
          left: "0%",
        }
      });

      // Add placeholder for remaining events (using first remaining event's properties as base)
      processedEvents.push({
        ...overlappingEvents[1], // Keep all original properties
        title: `+${overlappingEvents.length - 1}`,
        showTime: false,
        class: "placeholder-event",
        isPlaceholder: true,
        allEvents: overlappingEvents.slice(1), // Store all remaining events
        style: {
          width: "20%",
          height: "154px",
          left: "72%",
        }
      });

      // Mark all overlapping events as processed except the first one
      overlappingEvents.slice(1).forEach(event => processedEventIds.add(event.eventId));
    }
  }

  return processedEvents;
}

  contarctorRoute(id) {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: id,
      },
    };
  }
  getWeek($event) {
    this.weekDisable = false; //reset weekDisable
    this.week = [$event.startDate, $event.endDate];
    const calref = this.$refs.vuecalRef as any;
    this.scrollTo9();
    const startTime = new Date($event.startDate).getTime();
    const endTime = new Date($event.endDate).getTime();
    const currentDate = new Date().getTime();
    const isBetween = currentDate <= endTime && currentDate >= startTime;
    this.currentCellTime = isBetween ? new Date() : $event.startDate;
    calref.selectedDate = this.currentCellTime;
  }
  scrollTo9() {
    const calendar = document.querySelector("#vuecal .vuecal__bg");
    const hours = new Date().getHours() + new Date().getMinutes() / 60;
    calendar.scrollTo({ top: hours * 60, behavior: "smooth" });
  }

  get isLoaded(): boolean {
    return this.$apollo.queries.activities.loading;
  }
  dateRange(view) {
    return `${moment(view.startDate).format("MMM DD")} - ${moment(
      view.endDate
    ).format("MMM DD YYYY")}`;
  }

  get companiesQuery(): Object {
    const conditions: any[] = [
      {
        contractors: {
          user_id: { _eq: this.currentUser.id },
          deleted: { _eq: false },
          approved: { _eq: true },
        },
      },
    ];

    return {
      where: { _and: conditions },
      userId: this.currentUser.id,
    };
  }

  getCurrentTime() {
    return new Date();
  }
}
